import APIService from "./APIService";

export default class OrderService extends APIService {
  static load() {
    return this.get("/paymgr/check")
      .then(this.getResponseData)
      .catch(this.getResponseError);
  }
}
